// ML001-F0239. Hook half of the money-action gate; the predicate lives in ./moneyActionGate (pure, no imports).
import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { organisationApi } from '../../services/api';
import { canPerformMoneyActions } from './moneyActionGate';

const present = (value) => value !== null && value !== undefined && String(value) !== '';

// For surfaces that do not already hold the permissions (the history drawer): reads the viewer's own
// my-permissions for the organisation once, and answers false until it has an answer or on any failure.
export function useMoneyActionGate(orgId, targetUserId) {
  const { user } = useAuth() || {};
  const [permissions, setPermissions] = useState(null);
  useEffect(() => {
    let current = true;
    setPermissions(null);
    if (!present(orgId) || typeof organisationApi?.getMyPermissions !== 'function') return undefined;
    Promise.resolve()
      .then(() => organisationApi.getMyPermissions(orgId))
      .then((response) => {
        const body = response?.data?.data || response?.data || response || {};
        if (current) setPermissions(body.permissions || {});
      })
      .catch(() => { if (current) setPermissions({}); });
    return () => { current = false; };
  }, [orgId]);
  return canPerformMoneyActions({ permissions, viewerId: user?.id, targetUserId });
}
